import { Clock } from 'react-feather'
import Button from '@/components/Button'
import analytics from '@/utils/analytics'
import { hideAllTooltips } from '@/utils/index'

export default function StartTimeButton({
  setNewAnnotationStart,
  progress,
  className = '',
  isDemo,
}) {
  function setCurrentTime() {
    hideAllTooltips()
    analytics.track(`${isDemo ? '(Demo) ' : ''}Start time button`)
    setNewAnnotationStart(progress.playedSeconds)
  }

  return (
    <>
      <Button
        onClick={setCurrentTime}
        className={className}
        tooltipContent="Link to current video time"
        name="start-time-button"
        tabIndex={-1}
      >
        <Clock className="h-5 w-5" />
      </Button>
    </>
  )
}
